import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-assignemp',
  templateUrl: './assignemp.component.html',
  styleUrls: ['./assignemp.component.scss']
})
export class AssignempComponent implements OnInit {

  Client: string;
  Contract: string;
  description: string;
  AssignService: string;
  Employee: string;
  Role: string;
  StartDate: string;
  EndDate: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  isShownActive: boolean = true;
  isShownUpdateBtn: boolean = true;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  AssignempExport = [] as any;
  AsEmp = [] as any;
  Contracts = [];
  contractsid: string;
  contractNum: string;
  Clients = [];
  onboardingid: string;
  Employees = [];
  empid: string;
  empName: string;
  EditedAssignEmp = [] as any;
  EditedAssignEmpId: string;
  EditedAssignServiceId: string;
  AsEmpRemove = [] as any;
  sOnboardingId: string;
  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'clientid', 'contractid', 'assignService', 'status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('AssignEmpRead');
    this.vWrite = localStorage.getItem('AssignEmpWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }
    this.sOnboardingId = localStorage.getItem('OnboardingId');
    if (this.sOnboardingId == undefined || this.sOnboardingId == null || this.sOnboardingId == "0") {
      Swal.fire('', 'Please Select A Customer First!');
    }   

    this.BindContractDDL();
    this.BindClientDDL();
    this.BindAssignEmpGrid();
    this.BindEmployeeDDL();
    this.BindEmpExport();
    this.contractsid = "0";
    this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
  }


  BindContractDDL() {
    debugger;
    var vcustomcode = this.sOnboardingId;
    this.onboardingid =vcustomcode;
    let params = new HttpParams();
    params = params.append('donboardid', this.onboardingid);
    var value = this.http.get(environment.apiUrl + 'NDA/GetContractDDL', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        debugger;
        this.Contracts = data;
        this.contractsid = "0";
      });
  }


  BindClientDDL() {
    var value = this.http.get(environment.apiUrl + 'AssignEmp/GetOnboardDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.Clients = data;
          var vcustomcode = this.sOnboardingId;
          this.onboardingid =vcustomcode;
          debugger;   
         // this.onboardingid = "0";
        }
        else {
        };
      });
  }

  BindEmployeeDDL() {
    var value = this.http.get(environment.apiUrl + 'AssignEmp/GetEmployeeDDL').toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          debugger;
          this.Employees = data;
          this.empid = "0";
        }
        else {
        };
      });
  }

  SubmitAsEmp() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vClient = this.onboardingid;
    var vcontract = this.contractsid;
    var vdescription = this.description;
    debugger;

    if (vClient == undefined || vClient == "" || vClient == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Client.";
      return false;
    }

    if (vcontract == undefined || vcontract == "" || vcontract == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Contract.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }
    debugger;

    if (this.AsEmp != null) {
      if (this.AsEmp.length != 0) {
        for (var i = this.AsEmp.length - 1; i >= 0; i--) {
          var v1 = this.AsEmp[i].AssignService;
          var v2 = this.AsEmp[i].Employee;
          var v3 = this.AsEmp[i].Role;
          var v4 = this.AsEmp[i].StartDate;
          var v5 = this.AsEmp[i].EndDate;
          debugger;
          var vVarAssignService = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarEmployee = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarStartDate = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEndDate = ((document.getElementById(v5) as HTMLInputElement).value);
          debugger;
          if (vVarAssignService == undefined || vVarAssignService == "" || vVarAssignService == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Service.";
            return false;
          }
          if (vVarEmployee == undefined || vVarEmployee == "" || vVarEmployee == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Employee.";
            return false;
          }

          if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Role.";
            return false;
          }

          if (vVarStartDate == undefined || vVarStartDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Start Date.";
            return false;
          }

          if (vVarEndDate == undefined || vVarEndDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select End Date.";
            return false;
          }

          if (vVarStartDate > vVarEndDate) {
            this.isShownError = false;
            this.ErrorMsg = "End Date Should Greater then Start Date.";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Services..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dClient', this.onboardingid);
    params = params.append('dcontract', this.contractsid);
    params = params.append('ddescription', this.description);

    var value = this.http.get(environment.apiUrl + 'AssignEmp/InsertAssignEmp', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vAsempId = data;
        for (var i = this.AsEmp.length - 1; i >= 0; i--) {
          var v1 = this.AsEmp[i].AssignService;
          var v2 = this.AsEmp[i].Employee;
          var v3 = this.AsEmp[i].Role;
          var v4 = this.AsEmp[i].StartDate;
          var v5 = this.AsEmp[i].EndDate;
          debugger;
          var vVarAssignService = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarEmployee = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarStartDate = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEndDate = ((document.getElementById(v5) as HTMLInputElement).value);
          debugger;
          let params1 = new HttpParams();
          params1 = params1.append('iAsEmpId', vAsempId);
          params1 = params1.append('iAssignservive', vVarAssignService);
          params1 = params1.append('irole', vVarRole);
          params1 = params1.append('iEmployee', vVarEmployee);
          params1 = params1.append('iStartdate', vVarStartDate);
          params1 = params1.append('iEnddate', vVarEndDate);
          var value = this.http.get(environment.apiUrl + 'AssignEmp/InsertAssignService', { params: params1 }).toPromise().then(
            (data: any) => {
              debugger;
              //this.onboardingid = "";
              this.contractsid = "";
              this.description = "";
              this.AssignService = "";
              this.empName = "";
              this.Role = "";
              this.StartDate = "";
              this.EndDate = "";
              this.AsEmp = [];
              this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
              this.BindAssignEmpGrid();
              this.BindEmpExport();
              this.isShownSuccess = false;
              this.isShownActive = true;
              this.SuccessMsg = "AssignEmployee Inserted Sucessfully.";
              return false;
            }).catch((data: any) => {
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              //this.BindOnboardGrid(); 
              this.BindAssignEmpGrid();
              this.BindEmpExport();
              this.isShownSuccess = false;
              this.SuccessMsg = "AssignEmployee Inserted Sucessfully.";
              //this.onboardingid = "";
              this.contractsid = "";
              this.description = "";
              this.AssignService = "";
              this.empName = "";
              this.Role = "";
              this.StartDate = "";
              this.EndDate = "";
              this.AsEmp = [];
              this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
              this.isShownActive = true;
              return false;
            })
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }


  UpdateAsEmp() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vClient = this.onboardingid;
    var vcontract = this.contractsid;
    var vdescription = this.description;
    debugger;

    if (vClient == undefined || vClient == "" || vClient == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Client.";
      return false;
    }

    if (vcontract == undefined || vcontract == "" || vcontract == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please select Contract.";
      return false;
    }

    if (vdescription == undefined || vdescription == "" || vdescription == "0") {
      this.description = "";
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";
    debugger;

    if (this.AsEmp != null) {
      if (this.AsEmp.length != 0) {
        for (var i = this.AsEmp.length - 1; i >= 0; i--) {
          var v1 = this.AsEmp[i].AssignService;
          var v2 = this.AsEmp[i].Employee;
          var v3 = this.AsEmp[i].Role;
          var v4 = this.AsEmp[i].StartDate;
          var v5 = this.AsEmp[i].EndDate;
          debugger;
          var vVarAssignService = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarEmployee = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarStartDate = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEndDate = ((document.getElementById(v5) as HTMLInputElement).value);
          debugger;
          if (vVarAssignService == undefined || vVarAssignService == "" || vVarAssignService == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Service.";
            return false;
          }
          if (vVarEmployee == undefined || vVarEmployee == "" || vVarEmployee == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Employee.";
            return false;
          }

          if (vVarRole == undefined || vVarRole == "" || vVarRole == "0") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Role.";
            return false;
          }

          if (vVarStartDate == undefined || vVarStartDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select Start Date.";
            return false;
          }

          if (vVarEndDate == undefined || vVarEndDate == "") {
            this.isShownError = false;
            this.ErrorMsg = "Please Select End Date.";
            return false;
          }
          if (vVarStartDate > vVarEndDate) {
            this.isShownError = false;
            this.ErrorMsg = "End Date Should Greater then Start Date.";
            return false;
          }
        }
      }
    }
    else {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Services..";
      return false;
    }

    let params = new HttpParams();
    debugger;
    params = params.append('dClient', this.onboardingid);
    params = params.append('dcontract', this.contractsid);
    params = params.append('ddescription', this.description);
    params = params.append('iAssEmpId', this.EditedAssignEmpId);
    params = params.append('istatus', vStatus);

    var value = this.http.get(environment.apiUrl + 'AssignEmp/UpdateAssignEmp', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var vAsempId = data;
        var vassEmpServiceId = this.EditedAssignServiceId;
        for (var i = this.AsEmp.length - 1; i >= 0; i--) {
          var v1 = this.AsEmp[i].AssignService;
          var v2 = this.AsEmp[i].Employee;
          var v3 = this.AsEmp[i].Role;
          var v4 = this.AsEmp[i].StartDate;
          var v5 = this.AsEmp[i].EndDate;

          var vVarAssignService = ((document.getElementById(v1) as HTMLInputElement).value);
          var vVarEmployee = ((document.getElementById(v2) as HTMLInputElement).value);
          var vVarRole = ((document.getElementById(v3) as HTMLInputElement).value);
          var vVarStartDate = ((document.getElementById(v4) as HTMLInputElement).value);
          var vVarEndDate = ((document.getElementById(v5) as HTMLInputElement).value);

          let params1 = new HttpParams();
          params1 = params1.append('iAsEmpId', vAsempId);
          params1 = params1.append('iAssignservive', vVarAssignService);
          params1 = params1.append('irole', vVarRole);
          params1 = params1.append('iEmployee', vVarEmployee);
          params1 = params1.append('iStartdate', vVarStartDate);
          params1 = params1.append('iEnddate', vVarEndDate);
          params1 = params1.append('iEnddate', vVarEndDate);
          params1 = params1.append('iasserviceId', vassEmpServiceId);
          this.AsEmp = [];
          var value = this.http.get(environment.apiUrl + 'AssignEmp/UpdateAssignService', { params: params1 }).toPromise().then(
            (data: any) => {
              debugger;
              //this.onboardingid = "";
              var vcustomcode = this.sOnboardingId;
              this.onboardingid =vcustomcode;              
              this.contractsid = "";
              this.description = "";
              this.AssignService = "";
              this.empName = "";
              this.Role = "";
              this.StartDate = "";
              this.EndDate = "";

              this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
              this.BindAssignEmpGrid();
              this.BindEmpExport();
              this.BindContractDDL();
              this.isShownSuccess = false;
              this.isShownActive = true;
              this.isShownSaveBtn = false;
              this.isShownUpdateBtn = true;
              this.SuccessMsg = "AssignEmployee Updated Sucessfully.";
              return false;
            }).catch((data: any) => {
              var vDataError = JSON.stringify(data.error.text);
              var vErrorMsg = vDataError.replace('"', '');
              //this.BindOnboardGrid(); 
              this.BindAssignEmpGrid();
              this.BindEmpExport();              
              this.isShownSuccess = false;
              this.SuccessMsg = "AssignEmployee Updated Sucessfully.";
              //this.onboardingid = "";
              var vcustomcode = this.sOnboardingId;
              this.onboardingid =vcustomcode;
              this.contractsid = "";
              this.description = "";
              this.AssignService = "";
              this.empName = "";
              this.Role = "";
              this.StartDate = "";
              this.EndDate = "";
              //this.AsEmp = [];
              this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
              this.isShownActive = true;
              this.isShownSaveBtn = false;
              this.isShownUpdateBtn = true;
              this.BindContractDDL();
              return false;
            })
        }
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });

  }


  ClearAsEmp() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn = true;
    this.isShownActive = true;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.contractsid = "";
    //this.onboardingid = "";
    var vcustomcode = this.sOnboardingId;
    this.onboardingid =vcustomcode;
    this.Contract = "";
    this.description = "";
    this.AssignService = "";
    this.empName = "";
    this.Role = "";
    this.StartDate = "";
    this.EndDate = "";
    this.empid = "";
    this.AsEmp = [];
    this.AsEmp.push({ AssignService: "vAssignService1", Employee: "vEmployee1", Role: "vRole1", StartDate: "vStartDate1", EndDate: "vEndDate1" });
this.BindContractDDL();
  }

  EditAssignEmp(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn = false;
    this.isShownActive = false;
    this.isShownError = true;
    this.isShownSuccess = true;
    this.EditedAssignEmp = item;
    debugger;

    var vAssignId = this.EditedAssignEmp.assignEmpId;
    var vcustomerId = this.EditedAssignEmp.ndaId;
    var vcontractsId = this.EditedAssignEmp.contractsid;
    var vdescription = this.EditedAssignEmp.description;
    var vstatus = this.EditedAssignEmp.status;
    var vAssignserId = this.EditedAssignEmp.assignServiceId;
    debugger;

    this.onboardingid = vcustomerId;
    //this.contractsid = vcontractsId;

    let params = new HttpParams();
    params = params.append('donboardid', this.onboardingid);
    var value = this.http.get(environment.apiUrl + 'NDA/GetContractDDL', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        debugger;
        this.Contracts = data;
        this.contractsid = vcontractsId;
      });

    this.description = vdescription;
    this.EditedAssignServiceId = vAssignserId;
    if (vstatus == "Active") {
      this.Status = false;
    }
    else {
      this.Status = true;
    }
    debugger;
    this.EditedAssignEmpId = vAssignId;
    var value1 = this.http.get(environment.apiUrl + 'AssignEmp/GetAssignEmpForEdit?AsEmpId=' + vAssignId).toPromise().then(
      (data: any) => {
        debugger;
        if (data.length != 0) {
          var vData = data;

          debugger;
          //this.AsEmp = [] as any;
          this.AsEmp = [];
          for (var i = 0; i < data.length; i++) {
            var vLength = 0;
            if (this.AsEmp == null)
              vLength = 0;
            else
              vLength = this.AsEmp.length;
            var v1 = "AssignService" + (i + 1);
            var v2 = "Employee" + (i + 1);
            var v3 = "Role" + (i + 1);
            var v4 = "StartDate" + (i + 1);
            var v5 = "EndDate" + (i + 1);
            var v6 = "Empvar" + (vLength + 1);
            var vAssignEmpId = vData[i].asempid;


            this.AsEmp.push({ AssignService: v1, Employee: v2, Role: v3, StartDate: v4, EndDate: v5, AssigEmpId: vAssignEmpId, Empvar: v6 });
            debugger;
          }
          setTimeout(() => {


            for (var j = 0; j < this.AsEmp.length; j++) {
              debugger;

              var v11 = this.AsEmp[j].AssignService;
              var v12 = this.AsEmp[j].Employee;
              var v13 = this.AsEmp[j].Role;
              var v14 = this.AsEmp[j].StartDate;
              var v15 = this.AsEmp[j].EndDate;


              var AssignService = vData[j].service;
              var Employee = vData[j].employee;
              var Role = vData[j].role;
              var StartDate = vData[j].asstartdate;
              var EndDate = vData[j].asenddate;
              debugger;

              if (AssignService != null) {
                ((document.getElementById(v11) as HTMLInputElement).value) = AssignService;
              }
              debugger;
              if (Employee != null) {
                ((document.getElementById(v12) as HTMLInputElement).value) = Employee;
              }
              if (Role != null) {
                ((document.getElementById(v13) as HTMLInputElement).value) = Role;
              }
              if (StartDate != null) {
                var vvstartdate = StartDate;
                StartDate = new Date(new Date(vvstartdate).setDate(new Date(vvstartdate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v14) as HTMLInputElement).value) = StartDate;
              }
              if (EndDate != null) {
                var vvEnddate = EndDate;
                EndDate = new Date(new Date(vvEnddate).setDate(new Date(vvEnddate).getDate() + 1)).toISOString().split('T')[0];
                ((document.getElementById(v15) as HTMLInputElement).value) = EndDate;
              }
            }

          }, 2000);
        }
        else {

        }
      });
  }

  // Change(event: any) {
  //   debugger;
  //   var onbid = event.target.value;
  //   this.onboardingid = onbid;
  //   debugger;
  //   let params = new HttpParams();
  //   params = params.append('donboardid', this.onboardingid);
  //   var value = this.http.get(environment.apiUrl + 'NDA/GetContractDDL', { params: params }).toPromise().then(
  //     (data: any) => {
  //       debugger;
  //       //if (data.length != 0) {
  //       debugger;
  //       this.Contracts = data;
  //       this.contractsid = "0";
  //       // }
  //       // else {
  //       // };
  //     });
  // }


  AddEmp() {
    debugger;
    var vLength = this.AsEmp.length;
    var v1 = "vAssignService" + (vLength + 1);
    var v2 = "vEmployee" + (vLength + 1);
    var v3 = "vRole" + (vLength + 1);
    var v4 = "vStartDate" + (vLength + 1);
    var v5 = "vEndDate" + (vLength + 1);
    this.AsEmp.push({ AssignService: v1, Employee: v2, Role: v3, StartDate: v4, AssignEmployeeId: "", EndDate: v5 });
  }


  BindAssignEmpGrid() {
    var value = this.http.get(environment.apiUrl + 'AssignEmp/GetAssignForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }
  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindEmpExport() {
    var value = this.http.get(environment.apiUrl + 'AssignEmp/GetAssignForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.AssignempExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.AssignempExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'AssignEmployee');

    /* save to file */
    XLSX.writeFile(wb, "AssignEmployee.xlsx");

  }

  RemoveServices(item: any) {
    debugger;
    this.AsEmpRemove = item;

    if (this.AsEmp != null) {

      if (this.AsEmp.length != 0 && this.AsEmp.length != 1) {
        for (var i = this.AsEmp.length - 1; i >= 0; i--) {
          //vName: v1, vPrice: v2, vImage: v3
          var v1 = this.AsEmp[i].AssignService;
          var vNme = this.AsEmpRemove.AssignService;

          //if (v1 == vNme) {
          if (v1 == vNme) {
            Swal.fire({
              title: 'Are you sure?',
              text: 'You want to remove this Row!',

              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!',
              cancelButtonText: 'No, keep it'
            }).then((result) => {
              if (result.value) {
                this.AsEmp.splice(i, 1);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Swal.fire(
                //   'Cancelled',
                //   'Your Row is safe :)',
                //   'error'
                // )
              }
            })

          }
        }
        //}
      }
      else{
        Swal.fire('', 'You Cannot Delete The Master Record.')
      }
    }
  }
}
